<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <div class="mb-2 d-flex" style="justify-content: space-between; align-items: center;">
      <app-page-title [title]="customReportName"></app-page-title>
      <div class="text-sm-end">
        <a routerLink="/reports"><button type="button" class="btn btn-secondary btn-sm">Back To List</button></a>
      </div>
    </div>

    <!-- <app-page-title [title]="'Reports ' + customReportName"></app-page-title> -->
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="row mb-2">
                    <div class="col-md-4">
                        <label class="form-label"><b>Group By</b></label>
                        <small class="text-muted d-block mb-1"><i>Select a column to group the report data</i></small>
                      <ng-select placeholder="Select" [items]="groupedColumns" bindLabel="label" bindValue="value"
                        [(ngModel)]="currentGroup" (change)="onGroupChange()"
                        [appendTo]="'body'">
                      </ng-select>
                    </div>
                    <div class="col-md-8 d-flex justify-content-end align-items-end">
                      <button type="button" class="btn btn-primary btn-sm me-2" (click)="exportExcel()">
                        Export <i class="bx bx-download font-size-16 ms-1"></i>
                      </button>
                    </div>

                    <div class="col-md-3 mb-2 d-flex justify-content-end">
                      <button type="button" class="btn btn-success btn-sm d-flex" [disabled]="isdisabled"
                        (click)="openReportModal()">Save Report</button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                      [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                      [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                      [pagination]="true" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="card">
                <div class="card-body">
                  <div class="col-12">
                    <div class="card">
                      <ngb-accordion #a="ngbAccordion" class="accordion range-accordion" [activeIds]="['1']">
                        <ngb-panel id="1">
                          <ng-template ngbPanelTitle class="text-black">
                            <i class="bx bx-search text-primary me-1"></i> Search and filter your reports
                          </ng-template>
                          <ng-template ngbPanelContent>
                            <form [formGroup]="reportForm">
                              <div class="row">
                                <div *ngFor="let field of fields" class="col-md-6">
                                  <div class="mb-2">
                                    <!-- Dynamically add label with 'for' attribute and 'id' -->
                                    <label [for]="field.key" class="form-label">{{ field.key }}</label>

                                    <!-- Date Input -->
                                    <div *ngIf="field.type === 'date'">
                                      <input type="date" [id]="field.key" class="form-control form-control-sm"
                                        [formControlName]="field.key">
                                    </div>

                                    <!-- Text Input -->
                                    <div *ngIf="field.type === 'text'">
                                      <input type="text" [id]="field.key" class="form-control form-control-sm"
                                        [formControlName]="field.key">
                                    </div>

                                    <!-- Select Input -->
                                    <div *ngIf="field.type === 'Select'">
                                      <ng-select [id]="field.key" [items]="field.options" placeholder="Select"
                                        bindLabel="label" bindValue="value" [appendTo]="'body'" [openOnEnter]="false"
                                        [formControlName]="field.key">
                                      </ng-select>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </form>
                            <form [formGroup]="countryForm">
                              <div class="col-12 mt-2">
                                <div class="card" style="padding: 10px;">
                                  <div class="card-header bg-transparent border-bottom text-uppercase"
                                    style="box-shadow: none;border-radius: 0px !important;">Origin</div>
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="country" class="form-label">Country</label>
                                          <ng-select id="country" formControlName="ddlOriginCountry"
                                            placeholder="Select" [items]="countryList" bindLabel="name"
                                            [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onCountryChange('origin')">
                                          </ng-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="state" class="form-label">State</label>
                                          <ng-select id="state" formControlName="ddlOriginState" placeholder="Select"
                                            [items]="originStateList" bindLabel="name" [bindValue]="'isocode'"
                                            [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onStateChange('origin')" />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="city" class="form-label">City</label>
                                          <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" [items]="originCityList"
                                            bindLabel="name" [bindValue]="'isocode'" />
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12  mt-2">
                                <div class="card" style="padding: 10px;">
                                  <div class="card-header bg-transparent border-bottom text-uppercase"
                                    style="box-shadow: none;border-radius: 0px !important;">
                                    Destination</div>
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="country" class="form-label">Country</label>
                                          <ng-select id="country" formControlName="ddlDestinationCountry"
                                            placeholder="Select" [items]="countryList" bindLabel="name"
                                            [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onCountryChange()">
                                          </ng-select>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="state" class="form-label">State</label>
                                          <ng-select id="state" formControlName="ddlDestinationState"
                                            placeholder="Select" [items]="destinationStateList" bindLabel="name"
                                            [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                            (change)="onStateChange()" />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="mb-2">
                                          <label for="city" class="form-label">City</label>
                                          <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select"
                                            [appendTo]="'body'" [openOnEnter]="false" [items]="destinationCityList"
                                            bindLabel="name" [bindValue]="'isocode'" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <div class="col-sm-12"
                              style="display: flex; justify-content: space-between; align-items: center;">
                              <button type="button" class="btn btn-primary btn-sm"
                                (click)="getReportDetails()">Search</button>
                            </div>
                          </ng-template>
                        </ngb-panel>
                      </ngb-accordion>
                    </div>

                    <ngb-accordion #a="ngbAccordion" class="accordion range-accordion" [activeIds]="['2']">
                      <ngb-panel id="1">
                      <ng-template ngbPanelTitle class="text-black">
                        <i class="bx bx-calendar text-primary me-1"></i> Schedule
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <form [formGroup]="scheduleForm">
                        <div class="row">
                          <div class="col-md-12 mb-2">
                          <label class="form-label">Frequency <span class="mandatory">*</span></label>
                          <ng-select formControlName="frequency" [items]="frequencyOptions" 
                            bindLabel="label" bindValue="value" placeholder="Select frequency">
                          </ng-select>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                          <div class="mb-2">
                            <label class="form-label">Target <span class="mandatory">*</span></label>
                            <ng-select formControlName="targetType" [items]="targetOptions" 
                            (change)="onTargetChange()"
                              bindLabel="label" bindValue="value" placeholder="Select frequency">
                            </ng-select>
                            <!-- <div>
                              <div role="group" aria-label="radio button group" class="btn-group">
                                <input type="radio" id="btnradio4" autocomplete="off"
                                  formControlName="targetType" value="Customer" class="btn-check" >
                                <label for="btnradio4"
                                  class="btn btn-outline-secondary btn-sm">Customer</label>
                                <input type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                                  formControlName="targetType" value="Aggregated" >
                                <label for="btnradio5"
                                  class="btn btn-outline-secondary btn-sm">Aggregated</label>
                              </div>
                            </div> -->
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12 mb-2" *ngIf="scheduleForm.get('targetType').value === 'Aggregated'">
                                <label class="form-label">Email Recipients <span class="mandatory">*</span></label>
                                <!-- <ng-select [items]="[]" [multiple]="true" [addTag]="true" 
                              formControlName="emailIds" 
                              placeholder="Enter or select email addresses">
                            </ng-select> -->
                                <!-- <div *ngIf="scheduleForm.get('emailIds').touched && (scheduleForm.get('emailIds').hasError('required') || scheduleForm.get('emailIds').value?.length === 0)" class="invalid-feedback">
                              Email Recipients are required.
                            </div> -->
                                <input type="text" class="form-control form-control-sm" id="emailid"
                                  placeholder="Ex. abc@domain.com" formControlName="emailIds"
                                  [ngClass]="{'is-invalid': (isFormSubmitted || scheduleForm.get('emailIds').touched) && scheduleForm.get('emailIds').errors}" />
                                <div
                                  *ngIf="(isFormSubmitted || scheduleForm.get('emailIds').touched) && scheduleForm.get('emailIds').errors"
                                  class="invalid-feedback">
                                  <span *ngIf="scheduleForm.get('emailIds').errors.pattern">
                                    Invalid email format
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-2">
                                <div class="">
                                  <label for="status" class="form-label">Status</label>
                                  <div class="form-check form-switch form-switch-md">
                                    <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                      formControlName="active" [checked]="scheduleForm.get('active').value">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mt-2">
                                <button type="button" class="btn btn-primary btn-sm" (click)="saveSchedule()"
                                  [disabled]="!scheduleForm.valid">
                                  Save Schedule
                                </button>
                              </div>
                            </div>
                          </form>
                        </ng-template>
                      </ngb-panel>
                    </ngb-accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isModalOpen" class="modal">
    <div class="modal-content">
      <span class="right-bar-toggle float-end" class="close" (click)="hide()">&times;</span>
      <div class="modal-header">
        <h4 class="modal-title"> Add Report Name</h4>
      </div>

      <div class="h2-pad">
        <form [formGroup]="reportNewForm">
          <div class="col-md-12 mb-2">
            <label class="form-label">Report Name <span class="mandatory">*</span></label>
            <input type="text" class="form-control form-control-sm" maxlength="50"
              formControlName="txtReportName"
              [ngClass]="{'is-invalid': (isFormSubmitted || reportNewForm.get('txtReportName')?.touched) && reportNewForm.get('txtReportName')?.errors}">

            <div
              *ngIf="(isFormSubmitted || reportNewForm.get('txtReportName')?.touched) &&  reportNewForm.get('txtReportName')?.errors"
              class="invalid-feedback">
              <span *ngIf="reportNewForm.get('txtReportName')?.errors.required">Report
                Name is required</span>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-outline-dark" (click)="printData()">Print</button> -->
        <button type="button" class="btn btn-outline-dark" [disabled]="isdisabled"
        (click)="addReport()">Save</button>
      </div>
    </div>

  </div>

</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
  <app-forbidden></app-forbidden>
</ng-container>